"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductImplementationCommonDocumentStatus = void 0;
var ProductImplementationCommonDocumentStatus;
(function (ProductImplementationCommonDocumentStatus) {
    ProductImplementationCommonDocumentStatus["ACTIVE"] = "active";
    ProductImplementationCommonDocumentStatus["INACTIVE"] = "inactive";
})(ProductImplementationCommonDocumentStatus = exports.ProductImplementationCommonDocumentStatus || (exports.ProductImplementationCommonDocumentStatus = {}));
//# sourceMappingURL=product-implementation-common-document-status.enum.js.map